import { Tag } from '@lego/klik-ui';

export const severityColorMap: Record<string, string> = {
  CRITICAL: 'error',
  HIGH: 'error',
  MEDIUM: 'yellow',
  LOW: 'light-blue',
  INFORMATIONAL: 'slate',
  UNDEFINED: 'slate',
};

const severityWeight: Record<string, number> = {
  CRITICAL: 5,
  HIGH: 4,
  MEDIUM: 3,
  LOW: 2,
  INFORMATIONAL: 1,
  UNDEFINED: 0,
};

export const getSeverityWeight = (severity?: string): number =>
  severityWeight[severity ?? 'UNDEFINED'] ?? 0;

export const SeverityDetails = ({ severity }: { severity: string }) => {
  return <Tag colorScheme={severityColorMap[severity] ?? 'gray'}>{severity}</Tag>;
};
